<template>
  <div class="home">
    <!--头部-->
    <XDheader></XDheader>
    <div class="container">
      <!-- 主图轮播 -->
      <swiper></swiper>
      <!-- 报名+倒计时 -->
      <div class="row">
        <div class="col-md-8">
          <div class="ad-01" :style="{ 'background-image': 'url(' + appweb.sliders[2] + ')'}"></div>
        </div>
        <div class="col-md-4 time" v-bind:class="themes_countdown">
          <h4 class="countdownTitle">距离比赛开始</h4>
          <XDcountdown></XDcountdown>
        </div>
      </div>

      <div class="row">
        <div class="col-md-8" style>
          <div class="news">
            <div class="title" v-bind:class="themes_news_title">
              <i class="el-icon-tickets" style="margin:0 5px;"></i>
              <span class="tl">赛事动态</span>
            </div>
            <div class="content">
              <!-- 跳转到指定图文页面 -->
              <div
                class="row item"
                v-for="item in news"
                :key="item.id"
                @click="gotopath('/' + gameId + '/content/' + item.uuid)"
              >
                <!-- 新闻 -->
                <div class="date" v-bind:class="themes_news_date">
                  <span class="dd">{{ new Date(item.createtime) | moment("DD") }}</span>
                  <span class="mm">{{ new Date(item.createtime) | moment("YYYY-MM") }}</span>
                </div>
                <div class="ntitle" v-bind:class="themes_news_name">{{item.title}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 match-info">
          <!-- <div class="match-info-title" style="text-align: center; padding:15px 0px;"></div> -->
            <div
              class="wrap" title="比赛线路图"
              @click="gotopath('/' + gameId + '/content/' + appweb.lines.url)"
              :style="{ 'background-image': 'url(' + appweb.lines.cover + ')'}"></div>
        </div>
      </div>

      <!--功能区-->
      <div class="row fun-wrap">
        <div class="col-md-3" v-for="fun in appweb.functions" :key="fun.func">
          <div
            class="fun"
            :style="{ 'background-image': 'url(' + fun.url + ')'}"
            v-bind:class="themes_media_func"
            @click="gotopath('/' + gameId + '/func/'+fun.func)"
          >
            <h4 style="margin:0">{{fun.func}}</h4>
          </div>
        </div>
      </div>

      <!--媒体合作伙伴区-->
      <XDmediaPartner></XDmediaPartner>
    </div>
    <XDfooter></XDfooter>
  </div>
</template>

<script>
import api from "@/axios";
import { mapState, mapGetters } from "vuex";

export default {
  data() {
    return {
      sliderImg: 1,
      swiperOptionTop: {
        spaceBetween: 10,
        loop: true,
        loopedSlides: 5, //looped slides should be the same
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        observeParents: true,
        observer: true
      },
      swiperOptionThumbs: {
        spaceBetween: 10,
        slidesPerView: 4,
        touchRatio: 0.2,
        loop: true,
        loopedSlides: 5, //looped slides should be the same
        slideToClickedSlide: true,
        observeParents: true,
        observer: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      news: [],
      swiperSliders: []
    };
  },
  mounted() {
    // 倒计时
    this.getnews();
  },
  methods: {
    gotoMap() {
      return `https://uri.amap.com/marker?name=${this.match.name}&&position=${
        this.match.longitude
      },${this.match.latitude}`;
    },
    gotopath(path) {
      this.$router.push({ path });
    },
    goto(path) {
      if (path) {
        window.location.href = path;
      }
    },
    getnews() {
      api.homenews({ gameId: this.gameId }).then(({ data }) => {
        if (data.code === 0) {
          this.news = data.data;
          for (var i = 0; i < this.news.length; i++) {
            if (this.news[i].cover) {
              this.swiperSliders.push(this.news[i]);
            }
          }
        } else {
          this.$message.error(data.msg);
        }
      });
    }
  },
  computed: {
    themes_countdown: function() {
      return "themes_countdown_" + this.$store.state.appweb.themetype;
    },
    themes_media_func: function() {
      return "themes_media_func_" + this.$store.state.appweb.themetype;
    },
    themes_partner_name: function() {
      return "themes_partner_name_" + this.$store.state.appweb.themetype;
    },
    themes_news_title: function() {
      return "themes_news_title_" + this.$store.state.appweb.themetype;
    },
    themes_news_date: function() {
      return "themes_news_date_" + this.$store.state.appweb.themetype;
    },
    themes_news_name: function() {
      return "themes_news_name_" + this.$store.state.appweb.themetype;
    },
    ...mapState(["appweb", "gameId", "match"]),
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.xcxQR-wrap {
  display: flex;
  justify-content: left;
  align-items: center;
}
.xcxQR {
  width: 100px;
  height: 100px;
}
.mathch-tip {
  padding-left: 15px;
}
.match-info-content {
  color: #999;
}
.match-info{
    overflow: hidden;
}
.match-info-title {
  font-size: 20px;
  font-weight: 600;
}

.fun-wrap {
  margin: 0px -15px !important;
  background: url(/img/fun_img.jpg);
  justify-content: center;
  align-items: center;
}

.row {
  margin: 10px -1px;
  background: #fff;
}
.fun {
  border-radius: 5px;
  padding: 46px 8px;
  text-align: center;
  cursor: pointer;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}

.news {
  margin-left: -15px;
}
.news .title {
  border-radius: 5px;
}
.news .item {
  background: #eee;
  margin: 6px 0;
  cursor: pointer;
  display: flex;
}
.news .item[data-v-957c9522] {
  border-radius: 5px;
}
.news .item .date {
  text-align: center;
  padding: 0px 10px;
}
.news .item .date span {
  display: block;
}
.news .item .date span.dd {
  font-size: 30px;
  font-weight: bold;
}
.news .item .date span.mm {
  font-size: 15px;
}
.news .item .ntitle {
  padding: 23px 0;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-grow: 2;
}
div.title {
  padding: 20px 8px;
}
div.title span {
  font-size: 16px;
}
.news .item .col-md-3,
.col-md-4 {
  padding: 0;
}
.time {
  text-align: center;
}
.countdownTitle {
  padding: 10px;
}

.swiper-container {
  background-color: #000;
}
.swiper-slide {
  background-size: cover;
  background-position: center;
}
.slide {
  height: 330px;
}
.gallery-top {
  height: 70% !important;
  width: 100%;
}
.gallery-thumbs {
  height: 30% !important;
  box-sizing: border-box;
  padding: 10px 0;
}
.gallery-thumbs .swiper-slide {
  width: 25%;
  height: 100%;
  opacity: 0.4;
}
.gallery-thumbs .swiper-slide-active {
  opacity: 1;
}
.time[data-v-957c9522] {
  border-radius: 5px;
}
.gallery-top[data-v-957c9522] {
  border-radius: 5px 5px 0px 0px;
}
.gallery-thumbs[data-v-957c9522] {
  border-radius: 0px 0px 5px 5px;
}
/* .match-info .wrap { */
.wrap {
  height: 100%;
  margin: -5px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-clip:padding-box;
  cursor: pointer;
}
.ad-01 {
  height: 100%;
  margin-left: -15px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
</style>



// WEBPACK FOOTER //
// src/template/home/3-home.vue